export const staticCardsData = [
  {
    title: 'Team members with no progress',
    subTitle: '',
    value: 2,
    color: '',
  },
  {
    title: 'Team members with no feedback',
    subTitle: '',
    value: 3,
    color: '',
  },
  {
    title: 'Average proficiency',
    subTitle: 'since last month',
    value: '10%',
    count: '10%',
    color: 'warning',
  },
  {
    title: 'Team proficiency ranking',
    subTitle: 'since last month',
    value: '40%ile',
    count: '5%',
    color: 'success',
  },
];

export const staticLineChartData = {
  nodes: [
    {
      id: '121',
      name: 'Helen Mirren',
    },
    {
      id: '122',
      name: 'Ming Ye',
    },
    {
      id: '123',
      name: 'George Weber',
    },
    {
      id: '126',
      name: 'Jay Chandra',
    },
  ],
  series: [
    {
      data: [1, 30, 15, 22, 19, 28],
      id: '121',
    },
    {
      data: [15, 22.4, 14, 12, 12, 29],
      id: '122',
    },
    {
      data: [14, 28, 19, null, 11, 22],
      id: '123',
    },
    {
      data: [11, 18, 19, null, 21, 26],
      id: '124',
    },
    {
      data: [22, 15, 8, 11, 23, 15],
      id: '126',
    },
    {
      data: [14, 28, 19, null, 1, 22],
      id: '127',
    },
  ],

  xaxis: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
  yaxisRange: {
    start: 0,
    end: 30,
  },
};

export const staticBarChartData = {
  nodes: [
    {
      id: '121',
      name: 'Ownership',
    },
    {
      id: '122',
      name: 'Action-orientation',
    },
    {
      id: '123',
      name: 'Collaboration',
    },
    {
      id: '124',
      name: 'Customer centricity',
    },
    {
      id: '125',
      name: 'Manages ambiguity',
    },
    {
      id: '126',
      name: 'Innovation',
    },
    {
      id: '127',
      name: 'Accountability',
    },
  ],
  xaxis: ['Helen Mirren', 'Jay Chandra', 'George Weber', 'Ming Ye'],
  yaxisRange: {
    start: 0,
    end: 30,
  },
  series: [
    {
      data: [11, 12, 18, 22],
      id: '121',
    },
    {
      data: [5, 2.4, 4, 1],
      id: '122',
    },
    {
      data: [5, 2.4, 4, 1],
      id: '123',
    },
    {
      data: [4, 8, 9, null],
      id: '124',
    },
    {
      data: [13, 20, 12.4, 9],
      id: '125',
    },
    {
      data: [12, 15, 8, 19],
      id: '126',
    },
    {
      data: [12, 5, 18, 11],
      id: '127',
    },
  ],
};
